import { render } from "./CreateSubtaskModal.vue?vue&type=template&id=fa41aa00&scoped=true"
import script from "./CreateSubtaskModal.vue?vue&type=script&lang=js"
export * from "./CreateSubtaskModal.vue?vue&type=script&lang=js"

import "./CreateSubtaskModal.vue?vue&type=style&index=0&id=fa41aa00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa41aa00"]])

export default __exports__